<script>
import { RegionStore } from '../../store/regionStore';
export default {
  name: 'TheSiteFooter',
  mounted() {
    if (this.$refs.regionSelector) {
        this.$refs.regionSelector.addEventListener('change', this.handleRegionChange);
    }
  },
  methods: {
    handleRegionChange(event) {
      const selectedProvince = event.target.value;
      sessionStorage.setItem('selectedProvince',selectedProvince);
      event.target.form.submit();
   },
  }
};
</script>
